<div class="col-md-12" style="margin-left: -125px">
    <div class="tab-pane" role="tabpanel" id="formulario21">
        <fieldset id="agregar_formulario19" class="">
            <div class="container" id="center_div">
                <div class="row">
                    <div class="col-md-12">
                        <div id='page1' class="contenedorFormulario print-wrap page1">
                            <div>
                                <span style="float: right; clear: right;">(S.A.P. 5.1.5)</span> Formulario 2.1
                                <span style="float: right; clear: right;">1/3</span>
                            </div>
                            <h1><strong>SOLICITUD DE APROBACI&Oacute;N DE ANTEPROYECTO DE EDIFICACI&Oacute;N</strong></h1>
                            <br />
                            <table class="title">
                                <tr>
                                    <td>
                                        <div class="col-md-4"></div>
                                        <input disabled class="form-check-inline encab" type="checkbox" [checked]="tipo_aprobacion[0].aprobacion.uno" name="optradio1" id="optradio" />
                                        <label class="titleBox" for="optradio"> OBRA NUEVA</label>
                                    </td>
                                    <td>
                                        <input disabled class="form-check-inline encab" type="checkbox" [checked]="tipo_aprobacion[0].aprobacion.dos" name="optradio2" id="optradio" />
                                        <label class="titleBox" for="optradio"> AMPLIACI&Oacute;N</label>
                                    </td>
                                    <td>
                                        <input disabled class="form-check-inline encab" type="checkbox" [checked]="tipo_aprobacion[0].aprobacion.tres" name="optradio3" id="optradio" />
                                        <label class="titleBox" for="optradio"> ALTERACI&Oacute;N</label>
                                    </td>
                                    <td>
                                        <input disabled class="form-check-inline encab" type="checkbox" [checked]="tipo_aprobacion[0].aprobacion.cuatro" name="optradio3" id="optradio" />
                                        <label class="titleBox" for="optradio"> RECONSTRUCCI&Oacute;N</label>
                                    </td>
                                </tr>
                            </table>
                            <br />
                            <div class="row">
                                <div class="col-md-4">
                                    &nbsp;
                                </div>
                                <div class="col-md-4">
                                    <h2 class="infObligatorios">
                                        <strong> DIRECCION DE OBRAS - MUNICIPALIDAD DE {{nombreMuni | uppercase}}</strong></h2>
                                    <h2 class="infObligatorios"> {{region}} </h2>
                                    <table class="tablaConBorde">
                                        <tr>
                                            <td>
                                                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                <input disabled class="urb" type="checkbox" name="tpradio" id="tpradio" [checked]="propiedad[0].ubicacion == 'urbano'" />
                                                <label for="tpradio">URBANO</label>
                                                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                <input disabled class="urb" type="checkbox" name="tpradio" id="tpradio" [checked]="propiedad[0].ubicacion == 'rural'" />
                                                <label for="tpradio">RURAL</label>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <div class="col-md-4">
                                    <table style="float: right; clear: right; width: 140px;" class="tablaConBorde table">
                                        <tbody>
                                            <tr>
                                                <td align="center" class="fondoResaltado">
                                                    N&Uacute;MERO SOLICITUD
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">
                                                    <input class="form-control" type="text" id="num_sol" value="" name="num_sol" disabled />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center" class="fondoResaltado">
                                                    Fecha de Ingreso
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <input class="form-control" type="text" id="fecha_ingreso" value="" name="fecha_ingreso" disabled />
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td class="letraChica">
                                                    * A LLENAR POR LA D.O.M
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                            <br />
                            <div>
                                <table style="width: 100%;" class="tablaConBorde table">

                                    <tr class="rd_tipo">
                                        <td class="fondoResaltado izquierda" rowspan="2" style="width: 40%">
                                            CERTIFICADO DE INFORMACIONES PREVIAS:

                                        </td>
                                        <td class="fondoResaltado">
                                            N&uacute;mero
                                        </td>
                                        <td class="fondoResaltado">
                                            Fecha
                                        </td>

                                    </tr>
                                    <tr class="rd_tipo">
                                        <td>
                                            <input disabled class="form-control" type="text" name="certcip" id="certcip" [(ngModel)]="cip[0].certcip" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" type="text" name="fecha_cip" id="fecha_cip" [(ngModel)]="cip[0].fecha_cip" />
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div>
                                <div class="tituloSeccion">
                                    <span> 1.- DIRECCI&Oacute;N DE LA PROPIEDAD</span>
                                    <span class="help-block"></span>
                                </div>
                                <table style="width: 100%" border="0" class="tablaConBorde table">
                                    <tr class="fondoResaltado">
                                        <td style="width: 57%" colspan="3">
                                            CALLE O CAMINO
                                        </td>
                                        <td style="width: 24%">
                                            N&Uacute;MERO
                                        </td>
                                        <td style="width: 19%">
                                            ROL SII
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="3">
                                            <input disabled class="form-control" id="calle" name="calle" type="text" [(ngModel)]="propiedad[0].calle" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="numero" name="numero" type="text" [(ngModel)]="propiedad[0].calle_num" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="rol" name="rol" type="text" [(ngModel)]="propiedad[0].rol" />
                                        </td>

                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td style="width: 11%">
                                            MANZANA
                                        </td>
                                        <td style="width: 10%">
                                            LOTE
                                        </td>
                                        <td style="width: 61%" colspan="2">
                                            LOTEO O LOCALIDAD
                                        </td>
                                        <td style="width: 18%">
                                            PLANO DE LOTEO N°
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input disabled class="form-control" id="manzana" name="manzana" type="text" [(ngModel)]="propiedad[0].manzana" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" name="lote" id="lote" type="text" [(ngModel)]="propiedad[0].lote" />
                                        </td>
                                        <td colspan="2">
                                            <input disabled class="form-control" id="localidad" name="localidad" type="text" [(ngModel)]="propiedad[0].localidad" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="loteo_numero" name="loteo_numero" type="text" [(ngModel)]="propiedad[0].loteo_numero" />
                                        </td>
                                    </tr>
                                </table>

                            </div>
                            <div>
                                <div class="tituloSeccion">
                                    <span>2.- DECLARACION JURADA</span>
                                    <span class="help-block"></span>
                                </div>

                                <table style="width: 100%;" class="tablaConBordeExterno table">
                                    <tr>
                                        <td colspan="7"><input disabled class="form-control" id="nombre" name="nombre" type="text" [(ngModel)]="propietarios[0].nombre" /></td>
                                        <td align="right" colspan="4"><span>C&Eacute;DULA DE</span></td>

                                    </tr>
                                    <tr>
                                        <td align="left"><span>IDENTIDAD Nº</span></td>
                                        <td colspan="5"><input disabled class="form-control" id="rut" name="rut" type="text" [(ngModel)]="propietarios[0].rut" /></td>
                                        <td colspan="5" align="right"><span>DECLARA BAJO SU RESPONSABILIDAD</span></td>
                                    </tr>
                                    <tr>
                                        <td align="left"><span> SER</span></td>
                                        <td align="left"><span>PROPIETARIO</span></td>
                                        <td colspan="3" align="center"><span>(O  REPRESENTANTE  LEGAL  DEL  PROPIETARIO)</span> </td>
                                        <td colspan="2"><span>DEL  BIEN  RAIZ</span></td>
                                        <td align="left" colspan="4"><span>UBICADO  EN  CALLE/ </span></td>
                                    </tr>
                                    <tr>
                                        <td align="left"><span>/AVENIDA/CAMINO</span></td>
                                        <td align="right" colspan="3"><input disabled class="form-control" id="calle" name="calle" type="text" [(ngModel)]="propietarios[0].direccion" /></td>
                                        <td align="left" colspan="3"><span>NUMERO:</span> </td>
                                        <td align="left" colspan="4"><input disabled class="form-control" id="numero" name="numero" type="text" [(ngModel)]="propietarios[0].direccion_num" /></td>
                                    </tr>
                                    <tr>
                                        <td align="left"><span>ROL DE AVALUO Nº</span></td>
                                        <td align="right" colspan="2"><input disabled class="form-control" id="rol" name="rol" type="text" [(ngModel)]="propiedad[0].rol" /></td>
                                        <td align="left"> <span>DE LA COMUNA DE </span></td>
                                        <td align="right" colspan="7"><input disabled class="form-control" id="comuna" name="comuna" [(ngModel)]="propietarios[0].comuna" type="text" /></td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" align="left"><span>QUE SE ENCUENTRA INSCRITO A FOJAS</span></td>
                                        <td align="right"><input disabled class="form-control" id="inscripcion" name="inscripcion" type="text" [(ngModel)]="registro_bienes[0].inscrito" /></td>
                                        <td align="center"><span>N°</span></td>
                                        <td align="right" colspan="2"><input disabled class="form-control" id="num_insc" name="num_insc" type="text" [(ngModel)]="registro_bienes[0].numero" /></td>
                                        <td align="center"><span>AÑO</span></td>
                                        <td align="right"><input disabled class="form-control" id="anio_insc" name="anio_insc" type="text" [(ngModel)]="registro_bienes[0].anio" /></td>
                                        <td colspan="3" align="left"><span>DEL REGISTRO</span></td>
                                    </tr>
                                    <tr>
                                        <td align="left">DE PROPIEDAD</td>
                                        <td colspan="2" align="left"> DEL CONSERVADOR</td>
                                        <td align="left"> DE BIENES </td>
                                        <td align="left"> RAÍCES DE</td>
                                        <td align="left" colspan="6"><input disabled class="form-control" id="bienes" name="bienes" type="text" [(ngModel)]="registro_bienes[0].bienes" /></td>

                                    </tr>
                                    <tr>
                                        <td align="left">EN EL CUAL</td>
                                        <td align="left">SE EMPLAZA</td>
                                        <td colspan="2" align="left"><span>EL PROYECTO</span></td>
                                        <td align="left"><span>PARA EL QUE SE</span></td>
                                        <td colspan="6" align="left"><span>PRESENTA ESTA SOLICITUD</span></td>

                                    </tr>

                                </table>
                                <table class="tablaConBorde table">
                                    <tr>
                                        <td colspan="2" class="fondoResaltado izquierda" style="width: 40%;" align="left"><span>ADJUNTA PLANO TOPOGRAFICO (*)</span><span class="letraChica"> ART 1.4.8 OGUC</span></td>
                                        <td style="width: 5%; " align="center"><span><input disabled class="form-check-inline" type="checkbox" name="plano" id="plano"  [checked]="declaracion[0].plano == 'SI'"/>SI</span></td>
                                        <td style="width: 5%; " align="center"><span><input disabled class="form-check-inline" type="checkbox" name="plano" id="plano"  [checked]="declaracion[0].plano == 'NO'"/>NO</span></td>
                                        <td colspan="2" class="fondoResaltado" style="width: 50%; " align="left"><span></span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 20%; " align="left" class="fondoResaltado izquierda"><span>DENOMINADO: </span></td>
                                        <td colspan="5"><span><input disabled class="form-control" id="denominado" name="denominado" type="text" [(ngModel)]="declaracion[0].denominado"/></span></td>

                                    </tr>
                                    <tr>
                                        <td style="width: 20%; " align="left" class="fondoResaltado izquierda"><span>ELABORADO</span></td>
                                        <td colspan="3"><span><input disabled class="form-control" id="elaborado" name="elaborado" type="text" [(ngModel)]="declaracion[0].elaborado"/></span></td>
                                        <td style="width: 20%; " align="left" class="fondoResaltado izquierda"><span>DE PROFESION</span></td>
                                        <td><span><input disabled class="form-control" id="profesion" name="profesion" type="text" [(ngModel)]="declaracion[0].profesion" /></span></td>
                                    </tr>
                                </table>

                                <div class="letraChica"><span>NOTA: DE EXISTIR DOS O MÁS PROPIETARIOS, Y/O DOS O MÁS BIENES RAÍCES SE DEBERÁ ACOMPAÑAR HOJA ADJUNTA CON LOS DATOS Y FIRMAS CORRESPONDIENTE (*) SOLO EN LA EVENTUALIDAD QUE SE ACOMPAÑE DICHO PLANO.</span></div>

                            </div>
                            <div>
                                <div class="tituloSeccion">
                                    <span>3.- DATOS DEL PROPIETARIO O PROMITENTE COMPRADOR</span>
                                    <span class="help-block"></span>
                                </div>
                                <table class="tablaConBorde table form-group clone1">
                                    <tr class="fondoResaltado">
                                        <td colspan="2" style="width: 65%" align="left">
                                            NOMBRE O RAZ&Oacute;N SOCIAL
                                        </td>
                                        <td>
                                            R.U.T.
                                        </td>
                                        <td>
                                            FIRMA DEL PROPIETARIO
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2">
                                            <input disabled class="form-control" readonly id="nombre_prop" name="nombre_prop" type="text" [(ngModel)]="propietarios[0].nombre" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="rut_prop" name="rut_prop" type="text" [(ngModel)]="propietarios[0].rut" />
                                        </td>
                                        <td rowspan="7" class="alignBottom">
                                            <br>
                                            <br>
                                            <br>
                                            <br>
                                            <br>
                                            <br>
                                            <br>
                                            <br>
                                            <br> PERSONA NATURAL O <br>REPRESENTANTE LEGAL
                                        </td>

                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td colspan="2" style="width: 65%" align="left">
                                            REPRESENTANTE LEGAL
                                        </td>
                                        <td>
                                            R.U.T.
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2"><input disabled class="form-control" readonly id="nombre_rep" name="nombre_rep" type="text" [(ngModel)]="representantes[0].nombre" /></td>
                                        <td><input disabled class="form-control" id="rut_rep" name="rut_rep" type="text" [(ngModel)]="representantes[0].rut" /></td>
                                    </tr>

                                    <tr class="fondoResaltado">
                                        <td style="width: 25%" align="left">
                                            DIRECCI&Oacute;N / CALLE / PASAJE
                                        </td>
                                        <td style="width: 25%">
                                            N°
                                        </td>
                                        <td style="width: 25%">
                                            COMUNA
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="width: 25%">
                                            <input disabled class="form-control" id="direccion" name="direccion" type="text" [(ngModel)]="propietarios[0].direccion" />
                                        </td>
                                        <td style="width: 25%">
                                            <input disabled class="form-control" id="num" name="num" type="text" [(ngModel)]="propietarios[0].direccion_num" />
                                        </td>
                                        <td style="width: 25%">
                                            <input disabled class="form-control" id="comuna" name="comuna" type="text" [(ngModel)]="propietarios[0].comuna" />
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td align="left">
                                            E-MAIL
                                        </td>
                                        <td>
                                            TEL&Eacute;FONO
                                        </td>
                                        <td>
                                            FAX
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input disabled class="form-control" id="email_prop" name="email_prop" type="email" [(ngModel)]="propietarios[0].mail" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="tel_prop" name="tel_prop" type="text" [(ngModel)]="propietarios[0].fono" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="fax_prop" name="fax_prop" type="text" [(ngModel)]="propietarios[0].fax" />
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado tablaConBordeExterno table">
                                        <td colspan="4">
                                            PERSONERIA DEL REPRESENTANTE LEGAL
                                        </td>

                                    </tr>
                                    <tr>
                                        <td>
                                            SE ACREDITA MEDIANTE
                                        </td>
                                        <td colspan="3">
                                            <input disabled class="form-control" id="acredita" name="acredita" type="text" [(ngModel)]="permiso_notariado[0].acreditacion" />
                                        </td>

                                    </tr>
                                    <tr>
                                        <td>
                                            DE FECHA
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="fecha_acr" name="fecha_acr" type="text" [(ngModel)]="permiso_notariado[0].fecha" />
                                        </td>
                                        <td>
                                            Y REDUCIDA A ESCRITURA PUBLICA CON FECHA
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="fecha_esc" name="fecha_esc" type="text" [(ngModel)]="permiso_notariado[0].escritura" />
                                        </td>

                                    </tr>
                                    <tr>
                                        <td>
                                            ANTE EL NOTARIO SR(A)
                                        </td>
                                        <td colspan="3">
                                            <input disabled class="form-control" id="notario" name="notario" type="text" [(ngModel)]="permiso_notariado[0].notario" />
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div>
                                <div class="tituloSeccion">
                                    <span>4.- ARQUITECTO PROYECTISTA</span>
                                    <span class="help-block"></span>
                                </div>
                                <table class="tablaConBorde table form-group clone1">
                                    <tr class="fondoResaltado">
                                        <td colspan="2" style="width: 65%"><span>
                                                NOMBRE O RAZON SOCIAL DE LA EMPRESA</span><span class="letraChica"> (cuando corresponda)</span>
                                        </td>
                                        <td>
                                            R.U.T.
                                        </td>
                                        <td>
                                            FIRMA
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2">
                                            <input disabled class="form-control" readonly id="nombre_emp" name="nombre_emp" type="text" [(ngModel)]="empresas[0].nombre" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="rut_emp" name="rut_emp" type="text" [(ngModel)]="empresas[0].rut" />
                                        </td>
                                        <td rowspan="5"></td>

                                    </tr>
                                    <tr class="fondoResaltado ">
                                        <td colspan="2" style="width: 65%" align="left">
                                            NOMBRE ARQUITECTO RESPONSABLE
                                        </td>
                                        <td>
                                            R.U.T.
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2"><input disabled class="form-control" readonly id="nombre_arq" name="nombre_arq" type="text" [(ngModel)]="arquitectos[0].nombre" /></td>
                                        <td><input disabled class="form-control" id="rut_arq" name="rut_arq" type="text" [(ngModel)]="arquitectos[0].rut" /></td>
                                    </tr>

                                    <tr class="fondoResaltado">
                                        <td style="width: 25%" align="left">
                                            DIRECCI&Oacute;N / CALLE / PASAJE
                                        </td>
                                        <td style="width: 25%">
                                            N°
                                        </td>
                                        <td style="width: 25%">
                                            COMUNA
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="width: 25%">
                                            <input disabled class="form-control" id="direccion" name="direccion" type="text" [(ngModel)]="arquitectos[0].direccion" />
                                        </td>
                                        <td style="width: 25%">
                                            <input disabled class="form-control" id="num" name="num" type="text" [(ngModel)]="arquitectos[0].direccion_num" />
                                        </td>
                                        <td style="width: 25%">
                                            <input disabled class="form-control" id="comuna" name="comuna" type="text" [(ngModel)]="arquitectos[0].comuna" />
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td>
                                            E-MAIL
                                        </td>
                                        <td>
                                            TEL&Eacute;FONO
                                        </td>
                                        <td>
                                            FAX
                                        </td>
                                        <td>
                                            PATENTE PROFESIONAL N°
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input disabled class="form-control" id="email_arq" name="email_arq" type="email" [(ngModel)]="arquitectos[0].mail" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="tel_arq" name="tel_arq" type="text" [(ngModel)]="arquitectos[0].fono" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="fax_arq" name="fax_arq" type="text" [(ngModel)]="arquitectos[0].fax" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="pat_arq" name="pat_arq" type="text" [(ngModel)]="arquitectos[0].patente" />
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <br />
                            <br />
                            <br />
                            <br />
                        </div>
                        <div id='page2' class="contenedorFormulario print-wrap page2">
                            <div>
                                <span style="float: right; clear: right;">(S.A.P. 5.1.5)</span> Formulario 2.1
                                <span style="float: right; clear: right;">2/3</span>
                            </div>
                            <br />
                            <div>
                                <div class="tituloSeccion">
                                    <span>5.- CARACTER&Iacute;STICAS PRINCIPALES DEL ANTEPROYECTO</span>
                                    <span class="help-block letraChica">5.1.- DESTINO (S) CONTEMPLADO(S)</span>
                                </div>
                                <table class="tablaConBorde table form-group">
                                    <tr class="fondoResaltado">
                                        <td align="center" style="background: white"><input type="checkbox" disabled class="form-check-inline" readonly id="" name="residencial" value="SI" [checked]="destino[0].residencial" /></td>
                                        <td align="left">
                                            <span>RESIDENCIAL</span><br>
                                            <span>Art. 2.1.25.OGUC.</span>
                                        </td>
                                        <td>
                                            DESTINO ESPECIFICO
                                        </td>
                                        <td colspan="2">
                                            <input disabled class="form-control" readonly id="destino_resd" name="destino_resd" type="text" [(ngModel)]="destino[0].destino_resd" />
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td align="center" style="background: white" rowspan="2">
                                            <input type="checkbox" disabled class="form-check-inline" readonly id="equipamiento" name="equipamiento" value="SI" [checked]="destino[0].equipamiento" />
                                        </td>
                                        <td align="left" rowspan="2">
                                            <span>Equipamiento</span><br>
                                            <span>Art. 2.1.33.OGUC.</span>
                                        </td>
                                        <td>
                                            Clase Art.2.1.33 OGUC.
                                        </td>
                                        <td>
                                            Actividad
                                        </td>
                                        <td>
                                            Escala Art.2.1.36. OGUC.
                                        </td>
                                    </tr>
                                    <tr>

                                        <td>
                                            <input disabled class="form-control" readonly id="clase_eq" name="clase_eq" type="text" [(ngModel)]="destino[0].clase_eq" />
                                        </td>

                                        <td>
                                            <input disabled class="form-control" readonly id="actividad_eq" name="actividad_eq" type="text" [(ngModel)]="destino[0].actividad_eq" />
                                        </td>

                                        <td>
                                            <input disabled class="form-control" readonly id="total1" name="escala_eq" type="text" [(ngModel)]="destino[0].escala_eq" />
                                        </td>

                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td align="center" style="background: white"><input type="checkbox" disabled class="form-check-inline" readonly id="actividad" name="actividad" value="SI" [checked]="destino[0].actividad" /></td>
                                        <td align="left">
                                            <span>ACTIVIDADES PRODUCTIVOS</span><br>
                                            <span>Art. 2.1.28.OGUC.</span>
                                        </td>
                                        <td>
                                            DESTINO ESPECIFICO
                                        </td>
                                        <td colspan="2"><input disabled class="form-control" readonly id="destino_act" name="destino_act" type="text" [(ngModel)]="destino[0].destino_act" /></td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td align="center" style="background: white"><input type="checkbox" disabled class="form-check-inline" readonly id="infraestructura" name="infraestructura" value="SI" [checked]="destino[0].infraestructura" /></td>
                                        <td align="left">
                                            <span>INFRAESTRUCTURA</span><br>
                                            <span>Art. 2.1.29.OGUC.</span>
                                        </td>
                                        <td>
                                            DESTINO ESPECIFICO
                                        </td>
                                        <td colspan="2"><input disabled class="form-control" readonly id="destino_infr" name="destino_infr" type="text" [(ngModel)]="destino[0].destino_infr" /></td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td align="center" style="background: white"><input type="checkbox" disabled class="form-check-inline" readonly id="otros" name="otros" value="SI" [checked]="destino[0].otros" /></td>
                                        <td align="left">
                                            <span>OTROS</span><br>
                                        </td>
                                        <td>
                                            (especificar)
                                        </td>
                                        <td colspan="2"><input disabled class="form-control" readonly id="esp_otros" name="esp_otros" type="text" [(ngModel)]="destino[0].esp_otros" /></td>
                                    </tr>
                                </table>
                            </div>
                            <div>
                                <div class="tituloSeccion">
                                    <span class="help-block letraChica">5.2.- SUPERFICIES</span>
                                </div>
                                <table class="tablaConBorde table form-group">
                                    <tr class="fondoResaltado">
                                        <td>

                                        </td>
                                        <td>
                                            UTIL (m2)
                                        </td>
                                        <td>
                                            COM&Uacute;N (m2)
                                        </td>
                                        <td>
                                            TOTAL (m22)
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td align="left">
                                            S. EDIFICADA BAJO TERRENO
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="util1" name="util1" type="text" [(ngModel)]="superficie_anteproyecto[0].util1" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="comun1" name="comun1" type="text" [(ngModel)]="superficie_anteproyecto[0].comun1" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="total1" name="total1" type="text" [(ngModel)]="superficie_anteproyecto[0].total1" />
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td align="left">
                                            S. EDIFICADA SOBRE TERRENO
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="destino_infr" name="destino_infr" type="text" [(ngModel)]="superficie_anteproyecto[0].util2" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="destino_infr" name="destino_infr" type="text" [(ngModel)]="superficie_anteproyecto[0].comun2" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="destino_infr" name="destino_infr" type="text" [(ngModel)]="superficie_anteproyecto[0].total2" />
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td align="left">
                                            S. EDIFICACI&Oacute;N TOTAL
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="destino_infr" name="destino_infr" type="text" [(ngModel)]="superficie_anteproyecto[0].util3" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="destino_infr" name="destino_infr" type="text" [(ngModel)]="superficie_anteproyecto[0].comun3" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="destino_infr" name="destino_infr" type="text" [(ngModel)]="superficie_anteproyecto[0].total3" />
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td align="left">
                                            SUPERFICIE TOTAL TERRENO (m2)
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="totalt" name="totalt" type="text" [(ngModel)]="superficie_anteproyecto[0].totalt" />
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div>
                                <div class="tituloSeccion">
                                    <span class="help-block letraChica">5.3.-NORMAS URBANISTICAS APLICADAS</span>
                                </div>
                                <table class="tablaConBorde table form-group">
                                    <tr class="fondoResaltado">
                                        <td>

                                        </td>
                                        <td>
                                            PERMITIDO
                                        </td>
                                        <td>
                                            PROYECTADO
                                        </td>
                                        <td>

                                        </td>
                                        <td>
                                            PERMITIDO
                                        </td>
                                        <td>
                                            PROYECTADO
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td align="left">
                                            COEFICIENTE DE CONSTRUCTIBILIDAD
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="constr_perm" name="constr_perm" type="text" [(ngModel)]="normas_urbanisticas[0].constr_perm" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="constr_proy" name="constr_proy" type="text" [(ngModel)]="normas_urbanisticas[0].constr_proy" />
                                        </td>
                                        <td align="left">
                                            COEF. DE OCUPACI&Oacute;N DE SUELO
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="suelo_perm" name="suelo_perm" type="text" [(ngModel)]="normas_urbanisticas[0].suelo_perm" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="suelo_proy" name="suelo_proy" type="text" [(ngModel)]="normas_urbanisticas[0].suelo_proy" />
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td align="left">
                                            COEF.DE OCUPACI&Oacute; PISOS<br> SUPERIORES
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="ocup_perm" name="ocup_perm" type="text" [(ngModel)]="normas_urbanisticas[0].ocup_perm" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="ocup_proy" name="ocup_proy" type="text" [(ngModel)]="normas_urbanisticas[0].ocup_proy" />
                                        </td>
                                        <td align="left">
                                            DENSIDAD
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="densid_perm" name="densid_perm" type="text" [(ngModel)]="normas_urbanisticas[0].densid_perm" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="densid_proy" name="densid_proy" type="text" [(ngModel)]="normas_urbanisticas[0].densid_proy" />
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td align="left">
                                            ALTURA MAXIMA EN METRO o PISOS
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="alt_perm" name="alt_perm" type="text" [(ngModel)]="normas_urbanisticas[0].alt_perm" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="alt_proy" name="alt_proy" type="text" [(ngModel)]="normas_urbanisticas[0].alt_proy" />
                                        </td>
                                        <td align="left">
                                            ADOSAMIENTO
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="adosam_perm" name="adosam_perm" type="text" [(ngModel)]="normas_urbanisticas[0].adosam_perm" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="adosam_proy" name="adosam_proy" type="text" [(ngModel)]="normas_urbanisticas[0].adosam_proy" />
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td align="left">
                                            RASANTE
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="rasant_perm" name="rasant_perm" type="text" [(ngModel)]="normas_urbanisticas[0].rasant_perm" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="rasant_proy" name="rasant_proy" type="text" [(ngModel)]="normas_urbanisticas[0].rasant_proy" />
                                        </td>
                                        <td align="left">
                                            ANTEJARDIN
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="antej_perm" name="antej_perm" type="text" [(ngModel)]="normas_urbanisticas[0].antej_perm" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="antej_proy" name="antej_proy" type="text" [(ngModel)]="normas_urbanisticas[0].antej_proy" />
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td align="left">
                                            DISTANCIAMIENTO
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="dist_perm" name="dist_perm" type="text" [(ngModel)]="normas_urbanisticas[0].dist_perm" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="dist_proy" name="dist_proy" type="text" [(ngModel)]="normas_urbanisticas[0].dist_proy" />
                                        </td>
                                    </tr>
                                    <br>
                                    <tr class="fondoResaltado">
                                        <td align="left">
                                            ESTACIONAMIENTOS REQUERIDOS
                                        </td>
                                        <td colspan="2">
                                            <input disabled class="form-control" readonly id="est_req" name="est_req" type="text" [(ngModel)]="normas_urbanisticas[0].est_req" />
                                        </td>
                                        <td v>
                                            ESTACIONAMIENTOS PROYECTO
                                        </td>
                                        <td colspan="2">
                                            <input disabled class="form-control" readonly id="est_proy" name="est_proy" type="text" [(ngModel)]="normas_urbanisticas[0].est_proy" />
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div>
                                <div class="tituloSeccion">
                                    <span class="help-block letraChica">5.4.-CLASIFICACI&Oacute;N(ES) CONSTRUCCI&Oacute;N(ES) PREDOMINANTE(S)</span>
                                </div>
                                <table class="tablaConBorde table form-group">
                                    <tr class="fondoResaltado">
                                        <td>
                                            CLASIFICACI&Oacute;N
                                        </td>
                                        <td>
                                            m2
                                        </td>
                                        <td>
                                            CLASIFICACI&Oacute;N
                                        </td>
                                        <td>
                                            m2
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado0">
                                        <td style="max-width: 281px; min-width: 281px;">
                                            <input disabled class="form-control" readonly id="clasificacion" name="clasificacion" type="text" [(ngModel)]="clasificacion[0].clasificacion" />
                                        </td>
                                        <td style="max-width: 281px; min-width: 281px;">
                                            <input disabled class="form-control" readonly id="metro" name="metro" type="text" [(ngModel)]="clasificacion[0].metro" />
                                        </td>
                                        <td style="max-width: 281px; min-width: 281px;">
                                            <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="!clasificacion[1]" />
                                            <input disabled class="form-control" readonly id="clasificacion" name="clasificacion" type="text" *ngIf="clasificacion[1]" [(ngModel)]="clasificacion[1].clasificacion" />
                                        </td>
                                        <td style="max-width: 281px; min-width: 281px;">
                                            <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="!clasificacion[1]" />
                                            <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="clasificacion[1]" [(ngModel)]="clasificacion[1].metro" />
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado0">
                                        <td style="max-width: 281px; min-width: 281px;">
                                            <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="!clasificacion[2]" />
                                            <input disabled class="form-control" readonly id="clasificacion" name="clasificacion" type="text" *ngIf="clasificacion[2]" [(ngModel)]="clasificacion[2].clasificacion" />
                                        </td>
                                        <td style="max-width: 281px; min-width: 281px;">
                                            <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="!clasificacion[2]" />
                                            <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="clasificacion[2]" [(ngModel)]="clasificacion[2].metro" />
                                        </td>
                                        <td style="max-width: 281px; min-width: 281px;">
                                            <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="!clasificacion[3]" />
                                            <input disabled class="form-control" readonly id="clasificacion" name="clasificacion" type="text" *ngIf="clasificacion[3]" [(ngModel)]="clasificacion[3].clasificacion" />
                                        </td>
                                        <td style="max-width: 281px; min-width: 281px;">
                                            <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="!clasificacion[3]" />
                                            <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="clasificacion[3]" [(ngModel)]="clasificacion[3].metro" />
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado0">
                                        <td style="max-width: 281px; min-width: 281px;">
                                            <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="!clasificacion[4]" />
                                            <input disabled class="form-control" readonly id="clasificacion" name="clasificacion" type="text" *ngIf="clasificacion[4]" [(ngModel)]="clasificacion[4].clasificacion" />
                                        </td>
                                        <td style="max-width: 281px; min-width: 281px;">
                                            <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="!clasificacion[4]" />
                                            <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="clasificacion[4]" [(ngModel)]="clasificacion[4].metro" />
                                        </td>
                                        <td style="max-width: 281px; min-width: 281px;">
                                            <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="!clasificacion[5]" />
                                            <input disabled class="form-control" readonly id="clasificacion" name="clasificacion" type="text" *ngIf="clasificacion[5]" [(ngModel)]="clasificacion[5].clasificacion" />
                                        </td>
                                        <td style="max-width: 281px; min-width: 281px;">
                                            <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="!clasificacion[5]" />
                                            <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="clasificacion[5]" [(ngModel)]="clasificacion[5].metro" />
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div>
                                <div class="tituloSeccion">
                                    <span class="help-block letraChica">5.5.- DISPOSICIONES ESPECIALES A QUE SE ACOGER&Aacute; EL PROYECTO</span>
                                </div>
                                <table class="tablaConBorde table form-group">
                                    <tr class="">
                                        <td align="left" style="background: white">
                                            <input type="checkbox" disabled class="form-check-inline" readonly id="" name="disposicion1" value="SI" [checked]="disposiciones_esp[0].disposicion1" />
                                        </td>
                                        <td>
                                            D.F.L-Nº2 de 1959
                                        </td>
                                        <td align="left" style="background: white">
                                            <input type="checkbox" disabled class="form-check-inline" readonly id="" name="disposicion2" value="SI" [checked]="disposiciones_esp[0].disposicion2" />
                                        </td>
                                        <td>
                                            Ley Nº 19.537 Copropiedad <br> Inmobiliaria
                                        </td>
                                        <td align="left" style="background: white">
                                            <input type="checkbox" disabled class="form-check-inline" readonly id="" name="disposicion3" value="SI" [checked]="disposiciones_esp[0].disposicion3" />
                                        </td>
                                        <td>
                                            Proyecci&oacute;n sombras <br> Art. 2.6.11. OGUC
                                        </td>
                                        <td align="left" style="background: white">
                                            <input type="checkbox" disabled class="form-check-inline" readonly id="" name="disposicion4" value="SI" [checked]="disposiciones_esp[0].disposicion4" />
                                        </td>
                                        <td>
                                            Segunda Vivienda <br>Art.6.2.4. OGUC
                                        </td>
                                    </tr>
                                    <tr class="">
                                        <td align="left" style="background: white">
                                            <input type="checkbox" disabled class="form-check-inline" readonly id="" name="disposicion5" value="SI" [checked]="disposiciones_esp[0].disposicion5" />
                                        </td>
                                        <td colspan="3">
                                            Conjunto Arm&oacute;nico Art. 2.6.4. OGUC
                                        </td>
                                        <td align="left" style="background: white">
                                            <input type="checkbox" disabled class="form-check-inline" readonly id="" name="disposicion6" value="SI" [checked]="disposiciones_esp[0].disposicion6" />
                                        </td>
                                        <td>
                                            Beneficio Fusi&oacute;n Art. 63 LGUC
                                        </td>
                                        <td align="left" style="background: white">
                                            <input type="checkbox" disabled class="form-check-inline" readonly id="" name="disposicion7" value="SI" [checked]="disposiciones_esp[0].disposicion7" />
                                        </td>
                                        <td>
                                            Conj. Viv. Econ. <br> Art. 6.1.8. OGUC
                                        </td>
                                    </tr>
                                    <tr class="">
                                        <td align="left" style="background: white">
                                            <input type="checkbox" disabled class="form-check-inline" readonly id="" name="disposicion8" value="SI" [checked]="disposiciones_esp[0].disposicion8" />
                                        </td>
                                        <td colspan="7">
                                            Otro (especificar)
                                        </td>
                                    </tr>
                                </table>
                                <br />
                                <table class="tablaConBorde table form-group">
                                    <tr class="fondoResaltado">
                                        <td colspan="8" align="left">
                                            AUTORIZACIONES ESPECIALES LGUC
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td align="left" style="background: white">
                                            <input type="checkbox" disabled class="form-check-inline" readonly id="" name="autorizacion1" value="SI" [checked]="autorizaciones[0].Art121" /> Art. 121
                                        </td>
                                        <td align="left" style="background: white">
                                            <input type="checkbox" disabled class="form-check-inline" readonly id="" name="autorizacion2" value="SI" [checked]="autorizaciones[0].Art122" /> Art. 122
                                        </td>
                                        <td align="left" style="background: white">
                                            <input type="checkbox" disabled class="form-check-inline" readonly id="" name="autorizacion3" value="SI" [checked]="autorizaciones[0].Art123" /> Art. 123
                                        </td>
                                        <td align="left" style="background: white">
                                            <input type="checkbox" disabled class="form-check-inline" readonly id="" name="autorizacion4" value="SI" [checked]="autorizaciones[0].Art124" /> Art. 124
                                        </td>
                                        <td align="left" style="background: white">
                                            <input type="checkbox" disabled class="form-check-inline" readonly id="" name="autorizacion5" value="SI" [checked]="autorizaciones[0].Ley19537" /> Art. 55
                                        </td>
                                        <td colspan="3" align="left" style="background: white">
                                            <input type="checkbox" disabled class="form-check-inline" readonly id="" name="autorizacion6" value="SI" [checked]="autorizaciones[0].Otro" /> Otro (especificar)
                                        </td>
                                    </tr>
                                    <br>
                                    <tr>
                                        <td class="fondoResaltado" colspan="5" align="left">
                                            EDIFICIOS DE USO PUBLICO
                                        </td>
                                        <td align="left" style="background: white">
                                            <input type="checkbox" disabled class="form-check-inline" readonly id="" name="uso_publico" value="SI" [checked]="uso_publico[0].uso_publico == 'todo'" /> TODO
                                        </td>
                                        <td align="left" style="background: white">
                                            <input type="checkbox" disabled class="form-check-inline" readonly id="" name="uso_publico" value="SI" [checked]="uso_publico[0].uso_publico == 'parte'" /> PARTE
                                        </td>
                                        <td align="left" style="background: white">
                                            <input type="checkbox" disabled class="form-check-inline" readonly id="" name="uso_publico" value="SI" [checked]="uso_publico[0].uso_publico == 'no'" /> NO
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div>
                                <div class="tituloSeccion">
                                    <span class="help-block letraChica">5.6.- NUMERO DE UNIDADES TOTALES POR DESTINO</span>
                                </div>
                                <table class="tablaConBorde table form-group">
                                    <tr class="fondoResaltado">
                                        <td class="fondoResaltado" align="left">
                                            VIVIENDAS
                                        </td>
                                        <td align="center" style="background: white">
                                            <input disabled class="form-control" readonly id="vivienda" name="vivienda" type="text" [(ngModel)]="unidades[0].vivienda" />
                                        </td>
                                        <td class="fondoResaltado" align="left">
                                            OFICINAS
                                        </td>
                                        <td align="center" style="background: white">
                                            <input disabled class="form-control" readonly id="oficinas" name="oficinas" type="text" [(ngModel)]="unidades[0].oficinas" />
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td class="fondoResaltado" align="left">
                                            LOCALES COMERCIALES
                                        </td>
                                        <td align="center" style="background: white">
                                            <input disabled class="form-control" readonly id="locales" name="locales" type="text" [(ngModel)]="unidades[0].locales" />
                                        </td>
                                        <td class="fondoResaltado" align="left">
                                            ESTACIONAMIENTOS
                                        </td>
                                        <td align="center" style="background: white">
                                            <input disabled class="form-control" readonly id="estacionamientos" name="estacionamientos" type="text" [(ngModel)]="unidades[0].estacionamientos" />
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td class="fondoResaltado" align="left">
                                            OTROS (ESPECIFICAR)
                                        </td>
                                        <td colspan="3" align="center" style="background: white">
                                            <input disabled class="form-control" readonly id="otros" name="otros" type="text" [(ngModel)]="unidades[0].otros" />
                                        </td>
                                    </tr>
                                </table>
                                <br>
                                <table class="tablaConBorde table form-group">
                                    <tr class="fondoResaltado">
                                        <td class="fondoResaltado" colspan="2" style="text-align: left">
                                            PARA ANTEPROYECTOS DE CONDOMINIO TIPO B
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td class="fondoResaltado">
                                            SUPERFICIE TOTAL DE TERRENO
                                        </td>
                                        <td class="fondoResaltado">
                                            CANTIDAD DE SITIOS RESULTANTES
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td class="fondoResaltado">
                                            <input disabled class="form-control" readonly id="destino_infr" name="destino_infr" type="text" [(ngModel)]="anteproy_condominio[0].superficie" />
                                        </td>
                                        <td class="fondoResaltado">
                                            <input disabled class="form-control" readonly id="destino_infr" name="destino_infr" type="text" [(ngModel)]="anteproy_condominio[0].cantidad" />
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div>
                                <div class="tituloSeccion">
                                    <span>6.- CONDICIONANTES DEL ANTEPROYECTO</span>
                                    <span class="letraChica">  (TRAMITE PREVIO CONJUNTO O SIMULT&Aacute;NEO AL PERMISO)</span>
                                    <span class="help-block"></span>
                                </div>
                                <table class="tablaConBorde table form-group">
                                    <tr class="fondoResaltado">
                                        <td align="center" style="background: white">
                                            <input type="checkbox" disabled class="form-check-inline" readonly id="" name="condicion1" value="SI" [checked]="condiciones[0].condicion1" />
                                        </td>
                                        <td class="fondoResaltado" style="text-align: left">
                                            FUSI&Oacute;N
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td align="center" style="background: white">
                                            <input type="checkbox" disabled class="form-check-inline" readonly id="" name="condicion2" value="SI" [checked]="condiciones[0].condicion2" />
                                        </td>
                                        <td class="fondoResaltado" style="text-align: left">
                                            SUBDIVISI&Oacute;N
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td align="center" style="background: white">
                                            <input type="checkbox" disabled class="form-check-inline" readonly id="" name="condicion3" value="SI" [checked]="condiciones[0].condicion3" />
                                        </td>
                                        <td class="fondoResaltado" style="text-align: left">
                                            LOTEO
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td align="center" style="background: white">
                                            <input type="checkbox" disabled class="form-check-inline" readonly id="" name="condicion4" value="SI" [checked]="condiciones[0].condicion4" />
                                        </td>
                                        <td class="fondoResaltado" style="text-align: left">
                                            DIVISI&Oacute;N AFECTA
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td align="center" style="background: white">
                                            <input type="checkbox" disabled class="form-check-inline" readonly id="" name="condicion5" value="SI" [checked]="condiciones[0].condicion5" />
                                        </td>
                                        <td class="fondoResaltado" style="text-align: left">
                                            ESTUDIOS FUNDADOS POR &Aacute;REAS DE RIESGO (Art. 5.1.15. O.G.U.C.)
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td align="center" style="background: white">
                                            <input type="checkbox" disabled class="form-check-inline" readonly id="" name="condicion6" value="SI" [checked]="condiciones[0].condicion6" />
                                        </td>
                                        <td class="fondoResaltado" style="text-align: left">
                                            CAMBIO DE DESTINO
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td align="center" style="background: white">
                                            <input type="checkbox" disabled class="form-check-inline" readonly id="" name="condicion7" value="SI" [checked]="condiciones[0].condicion7" />
                                        </td>
                                        <td class="fondoResaltado" style="text-align: left">
                                            OTROS (especificar)
                                        </td>
                                    </tr>
                                </table>


                            </div>
                        </div>
                        <div id='page3' class="contenedorFormulario print-wrap page3">
                            <div style="margin-bottom: 30px">
                                <span style="float: right; clear: right;">(S.A.P. 5.1.5.)</span> <span>Formulario 2.1</span>
                                <span style="float: right; clear: right;">3/3</span>
                            </div>
                            <div>

                                <div class="col-md-6" style="padding-left: 0px">
                                    <div class="col-md-12 tituloSeccion" style="padding-left: 0px">
                                        <span>7.- PERMISOS ANTERIORES*</span>
                                        <span class="help-block"></span>
                                    </div>
                                    <table class="tablaConBorde table form-group">
                                        <tr class="fondoResaltado">
                                            <td>PERMISO PRIMITIVO</td>
                                            <td>Nº</td>
                                            <td>FECHA</td>
                                        </tr>

                                        <tr class="fondoResaltado" *ngFor="let permiso of perm">
                                            <td><input disabled class="form-control" readonly id="permiso" name="permiso" type="text" [(ngModel)]="permiso.permiso" /></td>
                                            <td><input disabled class="form-control" readonly id="numero" name="numero" type="text" [(ngModel)]="permiso.numero" /></td>
                                            <td><input disabled class="form-control" readonly id="fecha" name="fecha" type="text" [(ngModel)]="permiso.fecha" /></td>
                                        </tr>

                                    </table>
                                </div>
                                <div class="col-md-6" style="padding-right: 0px">
                                    <div class="col-md-12 tituloSeccion">
                                        <span>RECEPCIONES FINALES* <span class="letraChica">  (PARCIALES O TOTALES)</span></span>
                                        <span class="help-block"></span>
                                    </div>
                                    <table class="tablaConBorde table form-group">
                                        <tr class="fondoResaltado">
                                            <td>RECEPCI&Oacute;N</td>
                                            <td>Nº</td>
                                            <td>FECHA</td>
                                        </tr>

                                        <tr class="fondoResaltado" *ngFor="let recep of recep">
                                            <td><input disabled class="form-control" readonly id="permiso" name="permiso" type="text" [(ngModel)]="recep.permiso" /></td>
                                            <td><input disabled class="form-control" readonly id="numero" name="numero" type="text" [(ngModel)]="recep.numero" /></td>
                                            <td><input disabled class="form-control" readonly id="fecha" name="fecha" type="text" [(ngModel)]="recep.fecha" /></td>
                                        </tr>

                                    </table>

                                </div>
                            </div>

                            <br />
                            <div>
                                <div class="tituloSeccion">
                                    <span>8.- ANTECEDENTES QUE SE ADJUNTAN</span>
                                    <span class="help-block"></span>
                                    <span class="letraChica">(ART. 5.1.5/1.2.2/1.4.2. OGUC)</span>
                                </div>

                                <table class="tablaConBorde table form-group">
                                    <tr class="fondoResaltado">
                                        <td style="width: 10%">DOM</td>
                                        <td colspan="2" style="width: 40%"></td>
                                        <td style="width: 10%">DOM</td>
                                        <td colspan="2" style="width: 40%"></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 10%"></td>
                                        <td align="center"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" checked disabled/></td>
                                        <td><span>Listado de documentos y planos numerados</span></td>
                                        <td style="width: 10%"></td>
                                        <td align="center"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" checked disabled/></td>
                                        <td><span>Ubicaci&oacute;n del predio</span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 10%"></td>
                                        <td align="center"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" checked disabled/></td>
                                        <td><span>Fotocopia del certificado de informaciones previas vigente, salvo que se señale su fecha y n&uacute;mero en la presente solicitud</span></td>
                                        <td style="width: 10%"></td>
                                        <td align="center"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" checked disabled/></td>
                                        <td><span>Emplazamiento</span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 10%"></td>
                                        <td align="center"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" checked disabled/></td>
                                        <td><span>Fotocopia de la patente al d&iacute;a del arquitecto</span></td>
                                        <td style="width: 10%"></td>
                                        <td align="center"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" checked disabled/></td>
                                        <td><span>Plantas Esquem&aacute;ticas</span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 10%"></td>
                                        <td align="center"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" checked disabled/></td>
                                        <td><span>Presupuesto informativo de las obras correspondientes</span></td>
                                        <td style="width: 10%"></td>
                                        <td align="center"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" checked disabled/></td>
                                        <td><span>Siluetas de las Elevaciones</span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 10%"></td>
                                        <td align="center"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" checked disabled/></td>
                                        <td><span>Cuadro general de superficies, salvo que estuviese en los planos</span></td>
                                        <td style="width: 10%"></td>
                                        <td align="center"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" /></td>
                                        <td><span>Plano comparativo de sombras , cuando corresponda</span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 10%"></td>
                                        <td align="center"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" /></td>
                                        <td><span>Estudio de riesgo cuando corresponda (art. 5.1.15. OGUC)</span></td>
                                        <td style="width: 10%"></td>
                                        <td align="center"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" checked disabled/></td>
                                        <td><span>Cuadro general de superficies edificadas</span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 10%"></td>
                                        <td align="center"></td>
                                        <td><span></span></td>
                                        <td style="width: 10%"></td>
                                        <td align="center"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" /></td>
                                        <td><span>Otros (especificar)</span></td>
                                    </tr>
                                </table>


                            </div>
                            <br />
                            <div>
                                <div class="tituloSeccion">
                                    <span>9.- CONSIGNACI&Oacute;N DE DERECHOS PARA ANTEPROYECTO </span><span class="letraChica"> (A LLENAR POR LA D.O.M)</span>
                                    <span class="help-block"></span>
                                </div>

                                <table class="tablaConBorde table form-group">
                                    <tr class="fondoResaltado">
                                        <td colspan="2">CLASIFICACI&Oacute;N (ES) DE LA CONSTRUCCI&Oacute;N</td>
                                        <td colspan="3">
                                            <table>
                                                <tr class="fondoResaltado">
                                                    <td>
                                                        Clasificaci&oacute;n
                                                    </td>
                                                    <td>
                                                        m2
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <input disabled class="form-control" readonly id="total3" name="total3" type="text" />
                                                    </td>
                                                    <td>
                                                        <input disabled class="form-control" readonly id="total3" name="total3" type="text" />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <input disabled class="form-control" readonly id="total3" name="total3" type="text" />
                                                    </td>
                                                    <td>
                                                        <input disabled class="form-control" readonly id="total3" name="total3" type="text" />
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                        <tr>
                                            <td colspan="2">
                                                PRESUPUESTO
                                            </td>
                                            <td colspan="3">
                                                <input disabled value="$" class="form-control" readonly id="total3" name="total3" type="text" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                TOTAL DERECHOS MUNICIPALES
                                            </td>
                                            <td class="fondoResaltado" align="right">
                                                %
                                            </td>
                                            <td colspan="3">
                                                <input value="$" disabled class="form-control" readonly id="total3" name="total3" type="text" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                MONTO A CONSIGNAR AL INGRESO DE LA PRESENTE SOLICITUD
                                            </td>
                                            <td class="fondoResaltado" align="right">
                                                %
                                            </td>
                                            <td colspan="3">
                                                <input value="$" disabled class="form-control" readonly id="total3" name="total3" type="text" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                GIRO INGRESO MUNICIPAL
                                            </td>
                                            <td class="fondoResaltado" align="right">
                                                Nº
                                            </td>
                                            <td>
                                                <input disabled class="form-control" readonly id="total3" name="total3" type="text" />
                                            </td>
                                            <td class="fondoResaltado">
                                                Fecha
                                            </td>
                                            <td>
                                                <input disabled class="form-control" readonly id="total3" name="total3" type="text" />
                                            </td>
                                        </tr>
                                </table>
                            </div>
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <hr>
                            <div>
                                <div><span style="float: right; clear: right;">(S.A.P. 5.1.5)</span></div>
                                <div style="padding-left: 72px">
                                    <h1><strong>COMPROBANTE DE INGRESO</strong></h1>
                                </div>
                                <div class="col-md-12 tituloSeccion" align="center">
                                    <span>SOLICITUD DE APROBACI&Oacute;N DE ANTEPROYECTO DE EDIFICACI&Oacute;N</span>
                                    <span class="help-block"></span>
                                </div>
                            </div>
                            <br>
                            <table class="title">
                                <tr>
                                    <td>
                                        <div class="col-md-4"></div>
                                        <input disabled class="form-check-inline encab" type="checkbox" [checked]="tipo_aprobacion[0].aprobacion.uno" name="optradio1" id="optradio" />
                                        <label class="titleBox" for="optradio"> OBRA NUEVA</label>
                                    </td>
                                    <td>
                                        <input disabled class="form-check-inline encab" type="checkbox" [checked]="tipo_aprobacion[0].aprobacion.dos" name="optradio2" id="optradio" />
                                        <label class="titleBox" for="optradio"> AMPLIACI&Oacute;N</label>
                                    </td>
                                    <td>
                                        <input disabled class="form-check-inline encab" type="checkbox" [checked]="tipo_aprobacion[0].aprobacion.tres" name="optradio3" id="optradio" />
                                        <label class="titleBox" for="optradio"> ALTERACI&Oacute;N</label>
                                    </td>
                                    <td>
                                        <input disabled class="form-check-inline encab" type="checkbox" [checked]="tipo_aprobacion[0].aprobacion.cuatro" name="optradio3" id="optradio" />
                                        <label class="titleBox" for="optradio"> RECONSTRUCCI&Oacute;N</label>
                                    </td>
                                </tr>
                            </table>
                            <br />
                            <br />
                            <div>
                                <table class="tablaConBorde izquierda">
                                    <tr>
                                        <td class="fondoResaltado">MONTO CONSIGNADO AL INGRESO</td>
                                        <td><input disabled class="form-control" readonly id="monto" name="monto" type="text" value="$" /></td>
                                        <td class="fondoResaltado">GIM N°</td>
                                        <td><input disabled class="form-control" readonly id="gim" name="gim" type="text" /></td>
                                        <td class="fondoResaltado">FECHA</td>
                                        <td><input disabled class="form-control" readonly id="fecha" name="fecha" type="text" /></td>
                                    </tr>
                                </table>
                            </div>
                            <br />
                            <div class="row">
                                <div class="col-md-3">
                                    <table class="tablaConBordeExterno">
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr align="center">
                                            <td>FIRMA FUNCIONARIO.</td>
                                        </tr>
                                        <tr align="center">
                                            <td> Y TIMBRE D.O.M.</td>
                                        </tr>

                                    </table>

                                </div>
                                <br />
                                <div class="col-md-1"></div>
                                <div class="col-md-4">
                                    <h2 class="infObligatorios">
                                        <strong> DIRECCION DE OBRAS - MUNICIPALIDAD DE {{nombreMuni | uppercase}}</strong></h2>
                                    <h2 class="infObligatorios"> {{region}} </h2>
                                    <div>
                                        <table class="tablaConBorde">
                                            <tr>
                                                <td>
                                                    <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                    <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                    <input disabled class="urb" type="checkbox" name="tpradio" id="tpradio" [checked]="propiedad[0].ubicacion == 'urbano'" />
                                                    <label for="tpradio">URBANO</label>
                                                    <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                    <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                    <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                    <input disabled class="urb" type="checkbox" name="tpradio" id="tpradio" [checked]="propiedad[0].ubicacion == 'rural'" />
                                                    <label for="tpradio">RURAL</label>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <table style="float: right; clear: right; width: 140px;" class="tablaConBorde table">
                                        <tbody>
                                            <tr>
                                                <td align="center" class="fondoResaltado">
                                                    N&Uacute;MERO SOLICITUD
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">
                                                    <input class="form-control" type="text" id="num_sol" value="" name="num_sol" disabled />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center" class="fondoResaltado">
                                                    Fecha de Ingreso
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <input class="form-control" type="text" id="fecha_ingreso" value="" name="fecha_ingreso" disabled />
                                                </td>
                                            </tr>
                                        </tbody>

                                    </table>
                                </div>
                            </div>
                            <br />
                            <div>
                                <table class="tablaConBorde">
                                    <tr class="fondoResaltado">
                                        <td>CALLE O CAMINO</td>
                                        <td>N&Uacute;MERO</td>
                                    </tr>
                                    <tr>
                                        <td><input class="form-control" type="text" id="calle" name="calle" disabled [(ngModel)]="propiedad[0].calle" /></td>
                                        <td><input class="form-control" type="text" id="numero" name="numero" disabled [(ngModel)]="propiedad[0].calle_num" /></td>
                                    </tr>
                                </table>
                            </div>
                            <hr />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12" align="left">
                <button mat-raised-button color="primary" id="pdf-download-link" title="Descargar Formulario 2.1" (click)="captureScreen()">Descargar Formulario 2.1</button>
            </div>
        </fieldset>
    </div>
</div>